import { createFileRoute } from "@tanstack/react-router";
import { CouponsContainer } from "@/features/coupons";

export const Route = createFileRoute("/$store/_layout/coupons")({
	component: CouponsPage,
});

function CouponsPage() {
	return <CouponsContainer />;
}
